import styled from '@emotion/styled';
import COLORS from '@zola/zola-ui/src/styles/emotion/colors';
import FONTS from '@zola/zola-ui/src/styles/emotion/fonts';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${SPACING.LG};
  font-size: ${FONTS.FONT_SIZE_SMALL};

  & > * {
    width: 100%;
  }
`;

export const Title = styled.div`
  color: ${COLORS.BLACK};
  display: flex;
  font-size: ${FONTS.FONT_SIZE_LARGE};
  font-weight: ${FONTS.FONT_WEIGHT_SEMI_BOLD};
  margin-bottom: ${SPACING.SM};
`;

export const TextBox = styled.div`
  display: flex;
  margin-bottom: 16px;
  color: ${COLORS.EMPEROR};
`;

export const ButtonBox = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 0 -6px;
  align-items: center;

  button {
    margin: 0 6px !important;
  }
`;

export const QRPreviewBox = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-bottom: ${SPACING.LG};

  .selector-label {
    color: ${COLORS.EMPEROR};
  }

  img {
    margin-bottom: 16px;
  }
`;
